import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class EditModeBlockedEvent extends EventV2<object> {}
